export default __webpack_public_path__ + "static/media/spam.4f5b1e70.svg";